import { useEffect, useState } from 'react';
import { useStore } from '../store';

const AUTO_DISMISS_MS = 10_000;

export function UndoToast() {
  const undoSnapshot = useStore((s) => s.undoSnapshot);
  const undoLastApply = useStore((s) => s.undoLastApply);
  const dismissUndo = useStore((s) => s.dismissUndo);
  // Re-render every second so the countdown numeral stays fresh; the actual
  // dismiss is driven by setTimeout below.
  const [tick, setTick] = useState(0);

  useEffect(() => {
    if (!undoSnapshot) return;
    const start = Date.now();
    const interval = window.setInterval(() => setTick((n) => n + 1), 1000);
    const timer = window.setTimeout(() => dismissUndo(), AUTO_DISMISS_MS);
    return () => {
      window.clearInterval(interval);
      window.clearTimeout(timer);
      void start;
    };
    // Re-arm whenever a NEW snapshot lands (id-by-reference is enough since
    // applyPreset always writes a fresh object).
  }, [undoSnapshot, dismissUndo]);

  if (!undoSnapshot) return null;
  void tick;

  return (
    <div className="undo-toast" role="status" aria-live="polite">
      <span className="undo-toast-msg">
        <strong>{undoSnapshot.message}</strong>
      </span>
      <button
        type="button"
        className="undo-toast-undo"
        onClick={() => undoLastApply()}
        title="Restore the previous editor state"
      >
        Undo
      </button>
      <button
        type="button"
        className="undo-toast-close"
        onClick={() => dismissUndo()}
        aria-label="Dismiss"
        title="Dismiss"
      >
        ×
      </button>
    </div>
  );
}
